import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import AccordionItem from "../../Components/UI-Controls/Accordian/Accordian";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import Logo from "../../../src/Assets/Images/Logo 29.44 X 5.12.png";
import Selector from "../../../src/Assets/Images/Selector 20 X 20.png";
import MainLoader from "../../Components/UI-Controls/MainLoader/MainLoader";
import JoditEditor from "jodit-react";
import "../../../src/JoditEditorStyle.css";
import { security_key, Url, imageConfigEditor } from "../../Services/Api";
import CustomBtn from "../../Components/UI-Controls/Buttons/Btn";
import { useLocation, useNavigate } from "react-router-dom";
import { PiNotePencil } from "react-icons/pi";
import imageStatus from "../../../src/Assets/Images/StatusImg 20 x 20.png";
import imageVisibility from "../../../src/Assets/Images/Visibility 20 x 20.png";
import imagePublish from "../../../src/Assets/Images/Publish 20 x 20.png";
import { IoImageOutline } from "react-icons/io5";
import ImageGalleryPopup from "../../Components/UI-Controls/PopUp/ImageGalleryPapup/ImageGalleryPopup";
import { uploadImage } from "../../Services/functions";
import BottomToust from "../../Components/BottomToust/BottomToust";
import "../ECommerce/ECommerce.css";
import "../Blogs/Blogs.css";
import "../Page.css";

/* ─────────────────────────────────────────────
   AddLandingPage
   Handles: Add / Edit / View for Landing Pages
   API payload mirrors the postman schema.
───────────────────────────────────────────── */
const AddLandingPage = () => {
  /* ── routing ── */
  const location = useLocation();
  const navigate = useNavigate();
  const { page_Data, view_Data } = location.state || {};

  /* ── editor ref ── */
  const editor = useRef(null);

  /* ── loading / toast ── */
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState(null);
  const [showMessage, setShowMessage] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [submissionActive, setSubmissionActive] = useState(false);

  /* ── mode flags ── */
  const [isEditMode, setIsEditMode] = useState(false);
  const [isViewMode, setIsViewMode] = useState(false);
  const [isEditID, setIsEditID] = useState(null);

  /* ── sidebar display values ── */
  const [productStatus, setProductStatus] = useState("");
  const [productVisibility, setProductVisibility] = useState("");
  const [productPublishedStatus, setPublishedStatus] = useState("");

  /* ── editor tab ── */
  const [selectedTab, setSelectedTab] = useState("Visual");

  /* ── SEO preview tab ── */
  const [selectedView, setSelectedView] = useState("Web");
  const [isMobileAnimating, setIsMobileAnimating] = useState(false);
  const [isWebAnimating, setIsWebAnimating] = useState(false);

  /* ── SEO accordions (lower section) ── */
  const [accordionsOpen, setAccordionsOpen] = useState({});

  /* ── main form ── */
  const [formData, setFormData] = useState({
    title: "",
    slug: "",
    author: "",
    content: "",
    status: "draft",
  });

  /* ── SEO / meta ── */
  const [metaData, setMetaData] = useState({
    metaTitle: "",
    metaDescription: "",
    metaKeywords: "",
    canonicalUrl: "",
    robots: "",
    ogTitle: "",
    ogDescription: "",
    og_image: "",
    xTitle: "",
    xDescription: "",
    x_image: "",
    schemaMarkup: "",
    keyPhrases: [],
  });

  /* ── image gallery (featured image) ── */
  const [pageImage, setPageImage] = useState(null);
  const [modalView, setModalView] = useState(false);
  const [modaldata, setModalData] = useState([]);
  const [isUploaded, setIsUploaded] = useState(false);
  const [uploadedStatus, setUploadedStates] = useState(null);
  const [imageType, setImageType] = useState("");
  const [imageSendPayload, setImageSendPayload] = useState({
    file: null,
    alt_text: "",
    title: "",
    description: "",
    link_url: "",
  });

  /* ── og / x image state ── */
  const [selectedOgImage, setSelectedOgImage] = useState(null);
  const [selectedXImage, setSelectedXImage] = useState(null);

  /* ── key phrases accordion rows ── */
  const [accordions, setAccordions] = useState([
    { keyPhrase: "", isAccordionOpen: false },
  ]);

  /* ════════════════════════════════════
     Helpers
  ════════════════════════════════════ */
  const capitalizeFirstLetter = (str) =>
    str ? str.charAt(0).toUpperCase() + str.slice(1) : "";

  const formatDate = (dateString) => {
    if (!dateString) return "Not Published Yet";
    return new Date(dateString).toLocaleDateString();
  };
const generateSlug = (name) =>
  name
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-+/g, "-");
  /* ════════════════════════════════════
     Toast auto-hide
  ════════════════════════════════════ */
  useEffect(() => {
    if (showMessage) {
      const t = setTimeout(() => setShowMessage(false), 3000);
      return () => clearTimeout(t);
    }
  }, [showMessage]);

  /* ════════════════════════════════════
     Image gallery API
  ════════════════════════════════════ */
  const getApi = async () => {
    try {
      const response = await axios.get(`${Url}/api/v1/media/blogs/get`);
      setModalData(response.data.media);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getApi();
  }, []);

  useEffect(() => {
    if (isUploaded) {
      getApi();
      setIsUploaded(false);
    }
  }, [isUploaded]);

  /* ════════════════════════════════════
     Mode detection from route
  ════════════════════════════════════ */
  useEffect(() => {
    const path = location.pathname;
    const editMode = path.includes("Edit");
    const viewMode = path.includes("View");
    const data = editMode ? page_Data : viewMode ? view_Data : null;

    if (data) {
      const status = capitalizeFirstLetter(data.status || "Draft");
      const visibility = data.status === "draft" ? "Private" : "Public";
      const publishedDate =
        data.status === "draft"
          ? "Not Published Yet"
          : formatDate(data.updatedAt);

      setProductStatus(status);
      setProductVisibility(visibility);
      setPublishedStatus(publishedDate);

      if (editMode) {
        handleEditOperation(data);
        setIsEditMode(true);
        setIsViewMode(false);
      } else {
        handleViewOperation(data);
        setIsViewMode(true);
        setIsEditMode(false);
      }
    } else {
      resetForm();
      setIsViewMode(false);
      setIsEditMode(false);
    }
  }, [page_Data, view_Data, location.pathname]);

  /* ════════════════════════════════════
     Edit / View population
  ════════════════════════════════════ */
  const handleEditOperation = useCallback((data) => {
    setIsEditID(data._id);
    setFormData({
      title: data.title || "",
      slug: data.slug || "",
      author: data.author || "",
      content: data.content || "",
      status: data.status || "draft",
    });
    setMetaData({
      metaTitle: data.meta?.title || "",
      metaDescription: data.meta?.description || "",
      metaKeywords: data.meta?.keywords || "",
      canonicalUrl: data.meta?.canonical_url || "",
      robots: data.meta?.robots || "",
      ogTitle: data.meta?.og_title || "",
      ogDescription: data.meta?.og_description || "",
      og_image: data.meta?.og_image || "",
      xTitle: data.meta?.x_title || "",
      xDescription: data.meta?.x_description || "",
      x_image: data.meta?.x_image || "",
      schemaMarkup: data.meta?.schemaMarkup
        ? JSON.stringify(data.meta.schemaMarkup, null, 2)
        : "",
      keyPhrases: data.meta?.keywords
        ? data.meta.keywords.split(",").map((k) => k.trim())
        : [],
    });
    setPageImage(data.image || null);
    setSelectedOgImage(data.meta?.og_image || null);
    setSelectedXImage(data.meta?.x_image || null);
  }, []);

  const handleViewOperation = useCallback((data) => {
    handleEditOperation(data); // same population, view mode blocks inputs
  }, [handleEditOperation]);

  /* ════════════════════════════════════
     Reset
  ════════════════════════════════════ */
  const resetForm = () => {
    setFormData({ title: "", slug: "", author: "", content: "", status: "draft" });
    setMetaData({
      metaTitle: "", metaDescription: "", metaKeywords: "",
      canonicalUrl: "", robots: "", ogTitle: "", ogDescription: "",
      og_image: "", xTitle: "", xDescription: "", x_image: "",
      schemaMarkup: "", keyPhrases: [],
    });
    setPageImage(null);
    setSelectedOgImage(null);
    setSelectedXImage(null);
    setIsEditID(null);
    setIsEditMode(false);
    setIsViewMode(false);
    setProductStatus("");
    setProductVisibility("");
    setPublishedStatus("");
    setAccordions([{ keyPhrase: "", isAccordionOpen: false }]);
  };

  /* ════════════════════════════════════
     Input handlers
  ════════════════════════════════════ */
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const updated = { ...prev, [name]: value };
      if (name === "title") updated.slug = generateSlug(value);
      return updated;
    });
  };

  const handleMetaChange = (e) => {
    const { name, value } = e.target;
    setMetaData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditorChange = (newContent) => {
    setFormData((prev) => ({ ...prev, content: newContent }));
  };

  /* ════════════════════════════════════
     Image gallery handlers
  ════════════════════════════════════ */
  const handleGalleryModalOpen = (clickType) => {
    setModalView(true);
    setImageType(clickType);
  };

  const handleGalleryModalClose = () => {
    setModalView(false);
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    const api = `${Url}/api/v1/media/blogs/add`;
    if (file) {
      setImageSendPayload((prev) => ({ ...prev, file }));
      setUploadedStates("loading");
      const payload = new FormData();
      payload.append("image", file);
      payload.append("alt_text", imageSendPayload.alt_text);
      payload.append("title", imageSendPayload.title);
      payload.append("description", imageSendPayload.description);
      payload.append("link_url", imageSendPayload.link_url);
      await uploadImage(payload, api, setUploadedStates);
    }
    setIsUploaded(true);
  };

  const handleImageSelect = (image) => {
    switch (imageType) {
      case "page-image":
        setPageImage(image);
        break;
      case "og-image":
        setMetaData((prev) => ({ ...prev, og_image: image.image_url }));
        setSelectedOgImage(image.image_url);
        break;
      case "x-image":
        setMetaData((prev) => ({ ...prev, x_image: image.image_url }));
        setSelectedXImage(image.image_url);
        break;
      default:
        break;
    }
    setModalView(false);
  };

  const cancelPageImage = () => setPageImage(null);
  const cancelOgImage = () => {
    setSelectedOgImage(null);
    setMetaData((prev) => ({ ...prev, og_image: "" }));
  };
  const cancelXImage = () => {
    setSelectedXImage(null);
    setMetaData((prev) => ({ ...prev, x_image: "" }));
  };

  /* ════════════════════════════════════
     SEO accordion toggle
  ════════════════════════════════════ */
  const toggleAccordion = (index) => {
    setAccordionsOpen((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  /* ════════════════════════════════════
     SEO preview tab toggle
  ════════════════════════════════════ */
  const handleViewChange = (view) => {
    if (view === "Mobile") {
      setIsMobileAnimating(true);
      setTimeout(() => setIsMobileAnimating(false), 300);
    } else {
      setIsWebAnimating(true);
      setTimeout(() => setIsWebAnimating(false), 300);
    }
    setSelectedView(view);
  };

  /* ════════════════════════════════════
     Submit
  ════════════════════════════════════ */
  const handlePageSubmit = async (status) => {
    setLoadingButton(status);
    setIsLoading(true);
    setSubmissionActive(true);

    let schemaObj = {};
    try {
      if (metaData.schemaMarkup) schemaObj = JSON.parse(metaData.schemaMarkup);
    } catch {
      schemaObj = {};
    }

    const payload = {
      title: formData.title,
      slug: formData.slug,
      author: formData.author,
      content: formData.content,
      status,
      meta: {
        title: metaData.metaTitle,
        description: metaData.metaDescription,
        keywords: metaData.metaKeywords,
        canonical_url: metaData.canonicalUrl,
        robots: metaData.robots,
        og_title: metaData.ogTitle,
        og_description: metaData.ogDescription,
        og_image: metaData.og_image,
        x_title: metaData.xTitle,
        x_description: metaData.xDescription,
        x_image: metaData.x_image,
        schemaMarkup: schemaObj,
      },
    };

    if (pageImage?.image_url) payload.image = pageImage.image_url;

    const token = sessionStorage.getItem("authToken");
    const headers = {
      Authorization: `Bearer ${token}`,
      "x-api-key": security_key,
    };

    try {
      let message = isEditMode
        ? "Landing page updated successfully!"
        : "Landing page created successfully!";

      if (isEditMode) {
        await axios.put(
          `${Url}/api/v1/landing-pages/edit-landing-page/${isEditID}`,
          payload,
          { headers }
        );
      } else {
        await axios.post(`${Url}/api/v1/landing-pages/create-landing-page`, payload, {
          headers,
        });
      }

      setToastMessage(message);
      setShowMessage(true);
      resetForm();

      setTimeout(() => {
        navigate("/Pages/Landing-Pages");
      }, 2000);
    } catch (error) {
      console.error("Error saving landing page:", error);
      setToastMessage(
        error.response?.data?.message ||
          "Failed to save landing page. Please try again."
      );
      setShowMessage(true);
    } finally {
      setIsLoading(false);
      setSubmissionActive(false);
      setLoadingButton(null);
    }
  };

  const handleCancel = () => {
    resetForm();
    navigate("/Pages/Landing-Pages");
  };

  const handleEditNavigation = () => {
    navigate(`/Pages/Landing-Pages/Edit/${view_Data._id}`, {
      state: { page_Data: view_Data },
    });
  };

  /* ════════════════════════════════════
     Right-side accordion items
  ════════════════════════════════════ */
  const rightAccordionItems = [
    {
      title: "Status",
      content: (
        <div className="Blogs-PublishContainer">
          {/* top action */}
          <div className="Blogs-StartContainer">
            {!isViewMode && (
              <CustomBtn
                label={
                  loadingButton === "published" ? (
                    <div className="btn-loader-Publish"></div>
                  ) : isEditMode ? (
                    "Save Draft"
                  ) : (
                    "Publish"
                  )
                }
                withIcon={false}
                disabled={loadingButton === "published"}
                className={`${isEditMode ? "DraftBtn" : "Blogs-PublishBtn"} ${
                  loadingButton === "draft" ? "active" : ""
                }`}
                onClick={() =>
                  handlePageSubmit(isEditMode ? "draft" : "published")
                }
                type="button"
              />
            )}
          </div>

          {/* meta rows */}
          <div className="Blogs-MidContainer">
            <div className="MidRowsData">
              <div className="RowContent">
                <img src={imageStatus} alt="Status" className="ImageStyle" />
                <span className="TextStyle1">Status:</span>
                <span className="TextStyle2">
                  {isEditMode || isViewMode ? productStatus : "Pending"}
                </span>
              </div>
              <PiNotePencil className="NoteIcon" />
            </div>
            <div className="MidRowsData">
              <div className="RowContent">
                <img
                  src={imageVisibility}
                  alt="Visibility"
                  className="ImageStyle"
                />
                <span className="TextStyle1">Visibility:</span>
                <span className="TextStyle2">
                  {isEditMode || isViewMode ? productVisibility : "Private"}
                </span>
              </div>
              <PiNotePencil className="NoteIcon" />
            </div>
            <div className="MidRowsData">
              <div className="RowContent">
                <img
                  src={imagePublish}
                  alt="Publish"
                  className="ImageStyle"
                />
                <span className="TextStyle1">Published:</span>
                <span className="TextStyle2">
                  {isEditMode || isViewMode
                    ? productPublishedStatus
                    : "Not set"}
                </span>
              </div>
              <PiNotePencil className="NoteIcon" />
            </div>
          </div>

          {/* bottom action */}
          <div className="Blogs-EndContainer">
            {isViewMode ? (
              <CustomBtn
                label="Edit Page"
                withIcon={false}
                disabled={false}
                className="ProductEditBtn"
                onClick={handleEditNavigation}
                type="button"
              />
            ) : (
              <CustomBtn
                label={
                  loadingButton === "draft" ? (
                    <div className="btn-loader-Draft"></div>
                  ) : isEditMode ? (
                    "Publish"
                  ) : (
                    "Save Draft"
                  )
                }
                withIcon={false}
                disabled={loadingButton === "draft"}
                className={`${isEditMode ? "ProductUpdateBtn" : "DraftBtn"} ${
                  loadingButton === "published" ? "active1" : ""
                }`}
                onClick={() =>
                  handlePageSubmit(isEditMode ? "published" : "draft")
                }
                type="button"
              />
            )}

            <CustomBtn
              label={
                isViewMode ? "Cancel View" : isEditMode ? "Cancel Edit" : "Cancel"
              }
              withIcon={false}
              disabled={false}
              className={isViewMode ? "CancelBtn-1" : "CancelBtn"}
              onClick={handleCancel}
              type="button"
            />
          </div>
        </div>
      ),
    },
  ];

  /* ════════════════════════════════════
     SEO lower section items (mirrors AddBlogs)
  ════════════════════════════════════ */
  const seoAccordionTitles = [
    "Search Appearance",
    "Open Graph (OG)",
    "X (Twitter) Card",
    "Schema Markup",
  ];

  /* ════════════════════════════════════
     Render
  ════════════════════════════════════ */
  return (
    <div className="AddProductPage">
      {loading && (
        <div className="backdrop">
          <div className="loader-container">
            <MainLoader />
          </div>
        </div>
      )}

      {/* ══════════════════════════════
          LEFT SIDE
      ══════════════════════════════ */}
      <div className="PageLeftSide">

        {/* ── Main content fields ── */}
        <div className="BlogsDescription">
          <div className="Blog-Container1-Row-1">
            {/* Title */}
            <div style={{ width: "63.5%" }}>
              <label htmlFor="title" className="DescriptionLabels">
                Title
              </label>
              <textarea
                id="title"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
                className="Blog-Title-Input"
                placeholder="Landing Page Title"
                disabled={isViewMode}
              />
            </div>

            {/* Author */}
            <div style={{ width: "35%" }}>
              <label htmlFor="author" className="DescriptionLabels">
                Author
              </label>
              <textarea
                id="author"
                name="author"
                value={formData.author}
                onChange={handleInputChange}
                className="Blog-Title-Input"
                placeholder="Admin"
                disabled={isViewMode}
              />
            </div>
          </div>

          {/* Slug row */}
          <div className="Blog-Container1-Row-1" style={{ marginTop: "12px" }}>
            <div style={{ width: "100%" }}>
              <label htmlFor="slug" className="DescriptionLabels">
                Slug
              </label>
              <input
                id="slug"
                name="slug"
                value={formData.slug}
                onChange={handleInputChange}
                className="Blog-Title-Input"
                style={{ padding: "8px 12px", height: "40px" }}
                placeholder="landing-page-slug"
                disabled={isViewMode}
              />
            </div>
          </div>

          {/* ── Rich Text Editor ── */}
          <div className="Blog-Container1-Row-2" style={{ marginTop: "12px" }}>
            <label htmlFor="editor" className="BlogContent-Heading">
              Page Content
            </label>
            <div className="Blogs-Editor-Container">
              <div className="Blogs-Editor-Tabs">
                <div
                  className={`Tab ${selectedTab === "Visual" ? "active" : ""}`}
                  onClick={() => setSelectedTab("Visual")}
                >
                  Visual
                </div>
                <div
                  className={`Tab ${selectedTab === "Text" ? "active" : ""}`}
                  onClick={() => setSelectedTab("Text")}
                >
                  Text
                </div>
              </div>
              <div className="Editor-Content">
                {selectedTab === "Visual" ? (
                  <JoditEditor
                    ref={editor}
                    value={formData.content}
                    tabIndex={1}
                    onBlur={handleEditorChange}
                    config={{
                      ...imageConfigEditor,
                      readonly: isViewMode,
                    }}
                  />
                ) : (
                  <textarea
                    id="content"
                    name="content"
                    value={formData.content}
                    readOnly={isViewMode}
                    onChange={handleInputChange}
                    className="Blog-Editor-Text-Area"
                    placeholder="<h1>Your page HTML here</h1>"
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        {/* ══════════════════════════════
            SEO SECTION  (mirrors AddBlogs)
        ══════════════════════════════ */}
        <div className="SEO">
          <div className="SEO-Header">
            <label>SEO</label>
          </div>
          <div className="SEO-Body">

            {/* Focus Keyphrase */}
            <div className="SEO-Row-1">
              <div className="Row-1-LeftSide">Focus Key Phrase</div>
              <div className="Row-1-RightSide">
                <textarea
                  name="metaKeywords"
                  value={metaData.metaKeywords}
                  onChange={handleMetaChange}
                  className="SEOinput-01"
                  placeholder="sofa, furniture, buying guide"
                  disabled={isViewMode}
                />
              </div>
            </div>

            {/* Dynamic accordion rows */}
            {seoAccordionTitles.map((title, index) => (
              <div key={index} className={`SEO-Row-${index + 2}`}>
                <div
                  onClick={() => toggleAccordion(index + 2)}
                  className="AccordionHeader"
                >
                  <span>{title}</span>
                  <div
                    className={`AccordionIcon ${
                      accordionsOpen[index + 2] ? "rotate" : ""
                    }`}
                  >
                    {accordionsOpen[index + 2] ? (
                      <FaChevronUp />
                    ) : (
                      <FaChevronDown />
                    )}
                  </div>
                </div>

                <div
                  className={`AccordionContent ${
                    accordionsOpen[index + 2] ? "open" : ""
                  }`}
                >
                  {/* ── Search Appearance ── */}
                  {title === "Search Appearance" && (
                    <>
                      {/* Web / Mobile preview toggle */}
                      <div className="ViewSelection">
                        <div className="CheckBtn">
                          <label
                            className={`MobileCheckLabel ${
                              isMobileAnimating && selectedView === "Mobile"
                                ? "MobileViewAnimate"
                                : ""
                            }`}
                          >
                            <input
                              type="radio"
                              name="seoViewOption"
                              value="Mobile"
                              checked={selectedView === "Mobile"}
                              onChange={() => handleViewChange("Mobile")}
                              className="MobileCheckBtn"
                            />
                            Mobile View
                          </label>
                          <label
                            className={`WebCheckLabel ${
                              isWebAnimating && selectedView === "Web"
                                ? "WebViewAnimate"
                                : ""
                            }`}
                          >
                            <input
                              type="radio"
                              name="seoViewOption"
                              value="Web"
                              checked={selectedView === "Web"}
                              onChange={() => handleViewChange("Web")}
                              className="WebCheckBtn"
                            />
                            Web View
                          </label>
                        </div>
                        <div className="ViewContent">
                          {selectedView === "Mobile" ? (
                            <div className="MobileViewContent">
                              <div className="Mobile-FirstRow">
                                <div className="MobileLogo">
                                  <img src={Logo} alt="Logo" />
                                </div>
                                <div className="MobileHeader">
                                  <span className="Header-Top">
                                    {metaData.metaTitle || "Page Title"}
                                  </span>
                                  <span className="Header-Bottom">
                                    yourdomain.com
                                  </span>
                                </div>
                                <div className="MobileSelector">
                                  <img src={Selector} alt="Selector" />
                                </div>
                              </div>
                              <div className="Mobile-SecondRow">
                                <span className="Header-Secondrow">
                                  {metaData.metaTitle || "– Page Title"}
                                </span>
                                <span className="Para-Secondrow">
                                  {metaData.metaDescription ||
                                    "Please provide a meta description."}
                                </span>
                              </div>
                            </div>
                          ) : (
                            <div className="WebViewContent">
                              <div className="Web-FirstRow">
                                <div className="WebLogo">
                                  <img src={Logo} alt="Logo" />
                                </div>
                                <div className="WebHeader">
                                  <span className="Header-Top">
                                    {metaData.metaTitle || "Page Title"}
                                  </span>
                                  <span className="Header-Bottom">
                                    yourdomain.com
                                  </span>
                                </div>
                                <div className="WebSelector">
                                  <img src={Selector} alt="Selector" />
                                </div>
                              </div>
                              <div className="Web-SecondRow">
                                <span className="Header2-Secondrow">
                                  {metaData.metaTitle || "– Page Title"}
                                </span>
                                <span className="Para2-Secondrow">
                                  {metaData.metaDescription ||
                                    "Please provide a meta description."}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* SEO Title */}
                      <div className="SEO-SearchAppearance SEO-Bordered">
                        <div className="Row-2-LeftSide">SEO Title</div>
                        <div className="Row-2-RightSide">
                          <textarea
                            name="metaTitle"
                            value={metaData.metaTitle}
                            onChange={handleMetaChange}
                            className="SEOinput-02"
                            placeholder=""
                            disabled={isViewMode}
                          />
                        </div>
                      </div>

                      {/* Canonical URL */}
                      <div className="SEO-SearchAppearance SEO-Bordered">
                        <div className="Row-2-LeftSide">Canonical URL</div>
                        <div className="Row-2-RightSide">
                          <textarea
                            name="canonicalUrl"
                            value={metaData.canonicalUrl}
                            onChange={handleMetaChange}
                            className="SEOinput-03"
                            placeholder="https://yourdomain.com/page-slug"
                            disabled={isViewMode}
                          />
                        </div>
                      </div>

                      {/* Meta Description */}
                      <div className="SEO-SearchAppearance SEO-Bordered">
                        <div className="Row-2-LeftSide">Meta Description</div>
                        <div className="Row-2-RightSide">
                          <textarea
                            name="metaDescription"
                            value={metaData.metaDescription}
                            onChange={handleMetaChange}
                            className="SEOinput-04"
                            placeholder="Learn how to choose the best sofa"
                            disabled={isViewMode}
                          />
                        </div>
                      </div>

                      {/* Robots */}
                      <div className="SEO-SearchAppearance">
                        <div className="Row-2-LeftSide">Robots</div>
                        <div className="Row-2-RightSide">
                          <textarea
                            name="robots"
                            value={metaData.robots}
                            onChange={handleMetaChange}
                            className="SEOinput-04"
                            placeholder="index,follow"
                            disabled={isViewMode}
                          />
                        </div>
                      </div>
                    </>
                  )}

                  {/* ── Open Graph ── */}
                  {title === "Open Graph (OG)" && (
                    <>
                      <div className="SEO-SearchAppearance SEO-Bordered">
                        <div className="Row-2-LeftSide">OG Title</div>
                        <div className="Row-2-RightSide">
                          <textarea
                            name="ogTitle"
                            value={metaData.ogTitle}
                            onChange={handleMetaChange}
                            className="SEOinput-02"
                            placeholder="Best Sofa Guide"
                            disabled={isViewMode}
                          />
                        </div>
                      </div>
                      <div className="SEO-SearchAppearance SEO-Bordered">
                        <div className="Row-2-LeftSide">OG Description</div>
                        <div className="Row-2-RightSide">
                          <textarea
                            name="ogDescription"
                            value={metaData.ogDescription}
                            onChange={handleMetaChange}
                            className="SEOinput-04"
                            placeholder="Complete sofa buying guide"
                            disabled={isViewMode}
                          />
                        </div>
                      </div>

                      {/* OG Image picker */}
                      <div className="SEO-SearchAppearance">
                        <div className="Row-2-LeftSide">OG Image</div>
                        <div className="Row-2-RightSide">
                          <div className="banner-upload" style={{ marginTop: "8px" }}>
                            {selectedOgImage ? (
                              <div className="image-preview-wrapper">
                                <img
                                  src={`${Url}${selectedOgImage}`}
                                  alt="OG"
                                  className="image-preview"
                                />
                                {!isViewMode && (
                                  <button
                                    onClick={cancelOgImage}
                                    className="cancel-button"
                                  >
                                    X
                                  </button>
                                )}
                              </div>
                            ) : (
                              !isViewMode && (
                                <label
                                  className="upload-label"
                                  onClick={() =>
                                    handleGalleryModalOpen("og-image")
                                  }
                                >
                                  <div className="Catupload-button">
                                    <IoImageOutline
                                      size={35}
                                      color="#555"
                                      className="uploaded-image"
                                    />
                                  </div>
                                  <span className="upload-text">
                                    Click to Upload OG Image
                                  </span>
                                </label>
                              )
                            )}
                          </div>
                        </div>
                      </div>
                      <ImageGalleryPopup
                        showImageGalleryPopUp={
                          modalView && imageType === "og-image"
                        }
                        handleModalView={handleGalleryModalClose}
                        handleFileChange={handleFileChange}
                        onImageSelect={handleImageSelect}
                        imageSendPayload={imageSendPayload}
                        setImageSendPayload={setImageSendPayload}
                        alt_text={imageSendPayload.alt_text}
                        title={imageSendPayload.title}
                        data={modaldata}
                        getData={getApi}
                      />
                    </>
                  )}

                  {/* ── X (Twitter) Card ── */}
                  {title === "X (Twitter) Card" && (
                    <>
                      <div className="SEO-SearchAppearance SEO-Bordered">
                        <div className="Row-2-LeftSide">X Title</div>
                        <div className="Row-2-RightSide">
                          <textarea
                            name="xTitle"
                            value={metaData.xTitle}
                            onChange={handleMetaChange}
                            className="SEOinput-02"
                            placeholder="Sofa Guide"
                            disabled={isViewMode}
                          />
                        </div>
                      </div>
                      <div className="SEO-SearchAppearance SEO-Bordered">
                        <div className="Row-2-LeftSide">X Description</div>
                        <div className="Row-2-RightSide">
                          <textarea
                            name="xDescription"
                            value={metaData.xDescription}
                            onChange={handleMetaChange}
                            className="SEOinput-04"
                            placeholder="How to choose sofas"
                            disabled={isViewMode}
                          />
                        </div>
                      </div>

                      {/* X Image picker */}
                      <div className="SEO-SearchAppearance">
                        <div className="Row-2-LeftSide">X Image</div>
                        <div className="Row-2-RightSide">
                          <div className="banner-upload" style={{ marginTop: "8px" }}>
                            {selectedXImage ? (
                              <div className="image-preview-wrapper">
                                <img
                                  src={`${Url}${selectedXImage}`}
                                  alt="X"
                                  className="image-preview"
                                />
                                {!isViewMode && (
                                  <button
                                    onClick={cancelXImage}
                                    className="cancel-button"
                                  >
                                    X
                                  </button>
                                )}
                              </div>
                            ) : (
                              !isViewMode && (
                                <label
                                  className="upload-label"
                                  onClick={() =>
                                    handleGalleryModalOpen("x-image")
                                  }
                                >
                                  <div className="Catupload-button">
                                    <IoImageOutline
                                      size={35}
                                      color="#555"
                                      className="uploaded-image"
                                    />
                                  </div>
                                  <span className="upload-text">
                                    Click to Upload X Image
                                  </span>
                                </label>
                              )
                            )}
                          </div>
                        </div>
                      </div>
                      <ImageGalleryPopup
                        showImageGalleryPopUp={
                          modalView && imageType === "x-image"
                        }
                        handleModalView={handleGalleryModalClose}
                        handleFileChange={handleFileChange}
                        onImageSelect={handleImageSelect}
                        imageSendPayload={imageSendPayload}
                        setImageSendPayload={setImageSendPayload}
                        alt_text={imageSendPayload.alt_text}
                        title={imageSendPayload.title}
                        data={modaldata}
                        getData={getApi}
                      />
                    </>
                  )}

                  {/* ── Schema Markup ── */}
                  {title === "Schema Markup" && (
                    <div className="SEO-SearchAppearance">
                      <div className="Row-2-LeftSide">JSON-LD Schema</div>
                      <div className="Row-2-RightSide">
                        <textarea
                          name="schemaMarkup"
                          value={metaData.schemaMarkup}
                          onChange={handleMetaChange}
                          className="SEOinput-04"
                          rows={6}
                          style={{ minHeight: "120px", fontFamily: "monospace" }}
                          placeholder={`{\n  "@context": "https://schema.org",\n  "@type": "Article"\n}`}
                          disabled={isViewMode}
                        />
                      </div>
                    </div>
                  )}

                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ══════════════════════════════
          RIGHT SIDE — accordions
      ══════════════════════════════ */}
      <div className="PageRightSide">
        {rightAccordionItems.map((item, index) => (
          <AccordionItem
            key={index}
            title={item.title}
            content={item.content}
            defaultOpen={index === 0}
            maxHeight="2000px"
          />
        ))}
      </div>

      <BottomToust
        showMessage={showMessage}
        message={toastMessage}
        // handleCloseMessageModal={handleCloseMessageModal}
      />
    </div>
  );
};

export default AddLandingPage;
